<template>
    <div class="footer">
        <main-container>
            <div class="menu">
                <a
                    v-for="item in footerItems"
                    :key="item.id"
                    class="link"
                    :href="`${item.link_to}${formatAnchorText(item)}`"
                    :download="item.custom && item.custom.type == 'Télécharger' ? '' : null"
                    :target="item.newTab ? '_blank' : ''"
                >
                    <typo name="body-12-normal">{{ item.label }}</typo>
                </a>
            </div>

            <div class="credits">
                <typo name="body-10-normal">
                    © 2004-{{ new Date().getFullYear() }}
                    DIODE
                </typo>
            </div>
        </main-container>
    </div>
</template>
<script>
import { Services } from "src/services/Services.js";

export default {
    methods: {
        formatAnchorText(item) {
            return item.link_anchor ? `?anchor=${item.link_anchor}` : "";
        },
    },
    asyncComputed: {
        async footerItems() {
            return await Services.wpApi.footerItems();
        },
    },
};
</script>

<style lang="sass" scoped>
.main-container
    display: flex
    flex-direction: column
    align-items: center
    padding: $padding-main
    +r(650)
        padding: 30px 12px
    +r(480)
        padding: 20px 12px 30px

    .typo
        color: $color-text

.menu
    +r(650)
        display: flex
        flex-wrap: wrap
        justify-content: center

    .link
        color: $color-text
        &:after
            content: "|"
            font-size: 10px
            padding: 0 20px
            +r(650)
                padding: 0 10px
        &:last-child:after
            display: none

.credits
    margin-top: 0.5em
@media print
    .menu
        display: none
</style>
